import { Form } from 'react-bootstrap';
import { ChangeEvent } from 'react';
import { Discount } from '../../../../shared/interfaces/discount.interface';

interface PaymentMethodListItemProps {
    label: string;
    installment?: number;
    reference: string;
    value?: number;
    onChange: (paymentKey: string, discount: Discount) => void;
}

export default function DiscountsListAccordionItem({
    label,
    installment,
    reference,
    value,
    onChange,
}: PaymentMethodListItemProps) {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newPercentage = Math.max(
            0,
            Math.min(100, parseFloat(e.target.value)),
        );

        const discountDto: Discount = {
            value: newPercentage,
            method: reference,
            installment: installment ?? 0,
        };

        const paymentKey = installment
            ? `${reference}-${installment}`
            : reference;
        onChange(paymentKey, discountDto);
    };

    return (
        <Form.Group controlId={`formPaymentMethod-${reference}-${installment}`}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                type="number"
                value={value || ''}
                onChange={handleChange}
                placeholder="Informe a % de desconto máximo..."
            />
        </Form.Group>
    );
}
